if( $('section#lightbox').length ) {

  var video_id = $('section#lightbox').attr('data-video-id');
  var video_hl = $('section#lightbox').attr('data-video-hl');
  var video_cc_load_policy = $('section#lightbox').attr('data-video-cc-load-policy');
  //- YT API
  var tag = document.createElement('script');
  tag.id = 'iframe-o5r';
  tag.src = 'https://www.youtube.com/iframe_api';
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  var player;
  function onYouTubeIframeAPIReady() {
    player = new YT.Player('player', {
      height: '100%',
      width: '100%',
      videoId: video_id,
      playerVars: {
        rel: 0,
        hl: video_hl,
        cc_load_policy: video_cc_load_policy,
      }
    });
  }

  $(function(){
    $('#extended-header').addClass('lightbox');

    $('button.lightbox, #lightbox').on('click', function(e){
      e.preventDefault();

      $('body').toggleClass('lightbox');
      $('.thumbnail').toggleClass('play');

      setTimeout(function() {
        $('.media').toggleClass('opacity');
      }, 200);

      setTimeout(function() {
        if($('body').hasClass('lightbox')){
          $('iframe').removeClass('hidden');
          player.playVideo();
        } else{
          player.pauseVideo();
          $('iframe').addClass('hidden');
        }
      }, 700);
    });
  });

}
